import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom/dist";
import { Col, Row } from "react-bootstrap";
import { CasinoProviders } from "../lib/data";
import Whatsapp from "../assets/images/Whatsapp.svg";
import Telegram from "../assets/images/Telegram.svg";
// import Facebook from "../assets/images/Facebook.svg";
import Instagram from "../assets/images/Instagram.svg";
import RNG from "../assets/images/providers/rng-certified.png";
import Gambling from "../assets/images/providers/gambling-commission.png";
import ResponsibleG from "../assets/images/providers/responsible-gaming.png";
import Gamble18 from "../assets/images/providers/gamble-resp-18.png";
import Betfair from "../assets/images/providers/betfair.png";
import ProviderLogo1 from "../assets/images/providers/Evolution.jpg";
import ProviderLogo2 from "../assets/images/providers/Ezugi.jpg";
import ProviderLogo3 from "../assets/images/providers/Supernowa.jpg";
import ProviderLogo4 from "../assets/images/providers/XPG.jpg";
import ProviderLogo5 from "../assets/images/providers/Vivogaming.jpg";
import ProviderLogo7 from "../assets/images/providers/OneTouch.jpg";
import ProviderLogo8 from "../assets/images/providers/Pragmaticplay.jpg";
import ProviderLogo9 from "../assets/images/providers/Onlyplay.jpg";
import ProviderLogo10 from "../assets/images/providers/AG.jpg";
import ProviderLogo11 from "../assets/images/providers/Microgaming.jpg";
import ProviderLogo12 from "../assets/images/providers/CQ9.jpg";
import ProviderLogo13 from "../assets/images/providers/JDB.jpg";
import ProviderLogo14 from "../assets/images/providers/Jili.jpg";
import PaymentLogo1 from "../assets/images/payments/visa.png";
import PaymentLogo2 from "../assets/images/payments/mastercard.png";
import PaymentLogo3 from "../assets/images/payments/Skrill.png";
import PaymentLogo4 from "../assets/images/payments/paytm.png";
import PaymentLogo5 from "../assets/images/payments/googlepay.png";
import PaymentLogo6 from "../assets/images/payments/UPI.png";
import PaymentLogo7 from "../assets/images/payments/phonepe.png";
import Aviator from "../assets/images/games-icon/Aviator.png";
import Ezugi from "../assets/images/games-icon/headicon/ezugi.png";
import Sports from "../assets/images/games-icon/headicon/sports.png";
import Evolution from "../assets/images/games-icon/headicon/evolution.png";
import HomeIcon from "../assets/images/games-icon/headicon/house.png";
import { FaDiamond } from "react-icons/fa6";
import { MdLanguage } from "react-icons/md";
import { HiSpeakerphone } from "react-icons/hi";
import { RiCustomerService2Fill } from "react-icons/ri";
import { FaBookOpen } from "react-icons/fa";
import { IoCubeSharp } from "react-icons/io5";
import { MdDownload } from "react-icons/md";
import { FaChevronRight } from "react-icons/fa";
import { IoHomeOutline } from "react-icons/io5";
import { MdOutlineSportsCricket } from "react-icons/md";
import { HiOutlineSpeakerphone } from "react-icons/hi";
import { CiWallet } from "react-icons/ci";
import { VscAccount } from "react-icons/vsc";
import Diamond from "../assets/images/icons/diamond.png";
import { handleRightSideBar } from "../redux/app/actions";
import { useDispatch } from "react-redux";

const footerPages = [
  "home",
  "sportsbook",
  "casino/evolution",
  "casino/ezugi",
  "gatewaylist",
];

const casinoProvidersGames = [
  {
    code: "evolution",
    name: "Evolution",
    imgUrl: ProviderLogo1,
    type: "evolution",
    status: 1,
  },
  {
    code: "ezugi",
    name: "Ezugi",
    imgUrl: ProviderLogo2,
    type: "ezugi",
    status: 2,
  },
  {
    code: "supernowa",
    name: "Supernowa",
    imgUrl: ProviderLogo3,
    type: "supernowa",
    status: 3,
  },
  {
    code: "xpg",
    name: "XPG",
    imgUrl: ProviderLogo4,
    type: "xpg",
    status: 4,
  },
  {
    code: "vivo",
    name: "Vivo",
    imgUrl: ProviderLogo5,
    type: "vivo",
    status: 5,
  },
  {
    code: "onetouch",
    name: "Onetouch",
    imgUrl: ProviderLogo7,
    type: "onetouch",
    status: 7,
  },
  {
    code: "pragmatic",
    name: "Pragmatic Play",
    imgUrl: ProviderLogo8,
    type: "pragmatic",
    status: 8,
  },
  {
    code: "onlyplay",
    name: "Only Play",
    imgUrl: ProviderLogo9,
    type: "onlyplay",
    status: 9,
  },
];

const Footer = () => {
  const navigate = useNavigate();
  const { appDetails } = useSelector((state) => state.app);
  const location = useLocation();
  const [activePage, setActivePage] = useState("");
  const { showRightSideBar } = useSelector((state) => state.app);
  const dispatch = useDispatch();

  useEffect(() => {
    const matchedValue = footerPages.find((f) =>
      location?.pathname.includes(f)
    );
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  return (
    <footer className="footer">
      <div className="inner-content">
        <div className="providers_sec">
          <Row>
            <Col md={6} xs={12}>
              <div className="provider-mob-border">
                <div className="heading ">
                  <div className="text">
                    <h5>
                      {" "}
                      <img
                        src={appDetails?.LOGO_URL}
                        alt="Logo"
                        style={{ width: "30%" }}
                      />
                    </h5>
                  </div>
                </div>

                <div className="providers_logo d-flex flex-wrap justify-content-center">
                  <a href="/casino/evolution" className="logo_box">
                    <img src={ProviderLogo1} alt="Provider Logo" />
                  </a>
                  <a href="casino/ezugi" className="logo_box">
                    <img src={ProviderLogo2} alt="Provider Logo" />
                  </a>
                  <a href="/casino/supernowa" className="logo_box">
                    <img src={ProviderLogo3} alt="Provider Logo" />
                  </a>
                  <a href="/casino/xpg" className="logo_box">
                    <img src={ProviderLogo4} alt="Provider Logo" />
                  </a>
                  <a href="/casino/vivo" className="logo_box">
                    <img src={ProviderLogo5} alt="Provider Logo" />
                  </a>
                  {/* <a href="/casino/qtech" className="logo_box">
                    <img src={ProviderLogo6} alt="Provider Logo" />
                  </a> */}
                  <a href="/casino/onetouch" className="logo_box">
                    <img src={ProviderLogo7} alt="Provider Logo" />
                  </a>
                  <a href="/casino/pragmatic" className="logo_box">
                    <img src={ProviderLogo8} alt="Provider Logo" />
                  </a>
                  <a href="/casino/onlyplay" className="logo_box">
                    <img src={ProviderLogo9} alt="Provider Logo" />
                  </a>
                  <a href="javascript:void(0)" className="logo_box">
                    <img src={ProviderLogo10} alt="Provider Logo" />
                  </a>
                  <a href="javascript:void(0)" className="logo_box">
                    <img src={ProviderLogo11} alt="Provider Logo" />
                  </a>
                  <a href="javascript:void(0)" className="logo_box">
                    <img src={ProviderLogo12} alt="Provider Logo" />
                  </a>
                  <a href="javascript:void(0)" className="logo_box">
                    <img src={ProviderLogo13} alt="Provider Logo" />
                  </a>
                  <a href="javascript:void(0)" className="logo_box">
                    <img src={ProviderLogo14} alt="Provider Logo" />
                  </a>
                </div>
                <div className="mt-2">
                  <p style={{ fontSize: "" }}>
                    <FaDiamond /> The platform advocates fairness, justice, and
                    openness. We mainly operate fair lottery, blockchain games,
                    live casinos, and slot machine games.
                  </p>
                  <p>
                    <FaDiamond /> Bigwinlottery works with more than 10,000
                    online live game dealers and slot games, all of which are
                    verified fair games.
                  </p>
                  <p>
                    <FaDiamond /> Bigwinlottery supports fast deposit and
                    withdrawal, and looks forward to your visit.
                  </p>
                  <p style={{ color: "red" }}>
                    Gambling can be addictive, please play rationally.
                  </p>
                  <p style={{ color: "red" }}>
                    Bigwinlottery only accepts customers above the age of 18.
                  </p>
                </div>
              </div>
            </Col>
            <Col
              md={6}
              xs={12}
              className="d-flex justify-content-center align-items-center"
            >
              <div className="">
                <div className="heading payment-heading mb-md-4 ">
                  <div className="helpLinks">
                    <ul>
                      <li>
                        <span>
                          <MdLanguage
                            style={{
                              fontSize: "xx-large",
                              marginRight: "5px",
                            }}
                          />
                        </span>{" "}
                        <div className="listItem">
                          Language <FaChevronRight />
                        </div>
                      </li>

                      <li>
                        {" "}
                        <span>
                          <HiSpeakerphone
                            style={{
                              fontSize: "xx-large",
                              marginRight: "5px",
                            }}
                          />
                        </span>{" "}
                        <div className="listItem">
                          Notification <FaChevronRight />
                        </div>
                      </li>
                      <li>
                        <a href="/customer-support">
                          <span>
                            <RiCustomerService2Fill
                              style={{
                                fontSize: "xx-large",
                                marginRight: "5px",
                              }}
                            />
                          </span>{" "}
                          <div className="listItem">
                            24/7 Customer service <FaChevronRight />
                          </div>
                        </a>
                      </li>
                      <li>
                        {" "}
                        <span>
                          <FaBookOpen
                            style={{
                              fontSize: "xx-large",
                              marginRight: "5px",
                            }}
                          />
                        </span>{" "}
                        <div className="listItem">
                          Beginners guide
                          <FaChevronRight />
                        </div>
                      </li>

                      <li>
                        {" "}
                        <span>
                          <IoCubeSharp
                            style={{
                              fontSize: "xx-large",
                              marginRight: "5px",
                            }}
                          />
                        </span>{" "}
                        <div className="listItem">
                          About us <FaChevronRight />
                        </div>
                      </li>

                      <li>
                        {" "}
                        <span>
                          <MdDownload
                            style={{
                              fontSize: "xx-large",
                              marginRight: "5px",
                            }}
                          />
                        </span>{" "}
                        <div className="listItem">
                          Download APP <FaChevronRight />
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <div className="container">
          {/* <div className="d-flex justify-content-center mt-2">
            <img
              src={PaymentMod}
              loading="lazy"
              style={{ width: "250px" }}
              alt="Payment Otions"
            />
          </div> */}

          <p>{appDetails?.FOOTER_TEXT || ""}</p>
          <div className="paymentImages d-none">
            <ul>
              <li>
                <img src="./images/sewa.jpeg" />
              </li>
              <li>
                <img src="./images/khalti.jpeg" />
              </li>
            </ul>
          </div>

          <div className="social-icons d-none">
            <ul>
              <li>
                <a
                  className="panel"
                  href={
                    appDetails?.WHATS_APP_URL != ""
                      ? appDetails?.WHATS_APP_URL
                      : "#"
                  }
                  target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                >
                  {/* <span className="notification-count">2</span> */}
                  <img src={Whatsapp} alt="Whatsapp Icon" />
                </a>
              </li>
              <li>
                <a
                  href={appDetails?.TELEGRAM != "" ? appDetails?.TELEGRAM : "#"}
                  target={appDetails?.TELEGRAM != "" ? "_blank" : ""}
                >
                  <img src={Telegram} alt="Telegram Icon" />
                </a>
              </li>
              <li>
                <a
                  href={appDetails?.FACEBOOK != "" ? appDetails?.FACEBOOK : "#"}
                  target={appDetails?.FACEBOOK != "" ? "_blank" : ""}
                >
                  <img src="/images/facebook-512.svg" alt="Facebook Icon" />
                </a>
              </li>
              <li>
                <a
                  href={
                    appDetails?.INSTATGRAM != "" ? appDetails?.INSTATGRAM : "#"
                  }
                  target={appDetails?.INSTATGRAM != "" ? "_blank" : ""}
                >
                  <img src={Instagram} alt="Instagram Icon" />
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-menu position-fixed start-0 bottom-0 z-index-2 d-block">
            <ul className="d-flex justify-content-evenly m-0 p-0 list-unstyled">
              {" "}
              <li>
                <a
                  className={activePage === "home" ? "active" : ""}
                  href="/home"
                >
                  <IoHomeOutline style={{ fontSize: "x-large" }} />
                  <span>Home</span>
                </a>
              </li>
              <li>
                <a
                  className={activePage === "activity" ? "active" : ""}
                  href="/activity"
                >
                  <MdOutlineSportsCricket style={{ fontSize: "x-large" }} />
                  <span>Activity</span>
                </a>
              </li>
              <li>
                <a
                  href="/promotion"
                  className={activePage === "promotion" ? "active" : ""}
                >
                  <div className="FooterMobImg">
                    <img
                      src={Diamond}
                      alt="Diamond"
                      style={{ fontSize: "x-large", borderRadius: "50%" }}
                    />
                  </div>
                  <span className="footercenter">Promotion</span>
                </a>
              </li>
              <li>
                <a href={"/wallet"}>
                  <CiWallet style={{ fontSize: "x-large" }} />
                  <span>Wallet</span>
                </a>
              </li>
              <li>
                <a
                  className={activePage === "gatewaylist" ? "active" : ""}
                  onClick={() => {
                    dispatch(handleRightSideBar(!showRightSideBar));
                  }}
                >
                  <VscAccount style={{ fontSize: "x-large" }} />
                  <span>Account</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
